/**
 * AppProviders — providers that live ABOVE the router.
 *
 * Only AuthProvider lives here. Providers that depend on router state
 * (TenantProvider, ApiClientProvider, TerminologyProvider) mount inside
 * the root route (__root.tsx) because they call useRouterState /
 * useParams, which only work under <RouterProvider>.
 */

import type { ReactElement, ReactNode } from "react";

import { AuthProvider } from "./AuthProvider";

export interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps): ReactElement {
  return <AuthProvider>{children}</AuthProvider>;
}
